import { lazy } from 'react';

const lazyDashboardPortfolioDiversification = lazy(
  async () => import('@/widgets/investor/dashboardPortfolioDiversification'),
);

const lazyDashboardHistoricalPortfolioDiversification = lazy(
  async () =>
    import('@/widgets/investor/dashboardHistoricalPortfolioDiversification'),
);

const investorWidgetMap = {
  /** Same component as Customize → Add Widget → Accounts (`investor-accounts-grid`). */
  'investor-account-list': lazy(
    async () => import('@/widgets/investor/PortfolioAccounts'),
  ),
  'investor-networth-trend': lazy(
    async () => import('@/widgets/investor/dashboardNetWorth'),
  ),
  'investor-cashflow-trend': lazy(
    async () => import('@/widgets/investor/dashboardCashFlow'),
  ),
  'investor-pd-historical': lazyDashboardHistoricalPortfolioDiversification,
  'investor-diversification': lazyDashboardPortfolioDiversification,
  'investor-financial-team': lazy(
    async () => import('@/widgets/investor/dashboardMyFinancialTeam'),
  ),
  'investor-quicklinks': lazy(
    async () => import('@/widgets/investor/dashboardQuickLinks'),
  ),
  'investor-resources': lazy(
    async () => import('@/widgets/investor/dashboardResources'),
  ),
  'investor-accounts-grid': lazy(
    async () => import('@/widgets/investor/PortfolioAccounts'),
  ),
  /** Managed Accounts — legacy/dashboard code still used by saved configs and metadata. */
  'investor-accounts-aum': lazy(
    async () => import('@/widgets/investor/ManagedAccountList'),
  ),
  'investor-holdings-grid': lazy(
    async () => import('@/widgets/investor/PortfolioHoldings'),
  ),
  'investor-trading-activity-grid': lazy(
    async () => import('@/widgets/investor/InvestmentActivity'),
  ),
  'investor-taxlots-grid': lazy(
    async () => import('@/modules/portfolio/gainLoss/GainLoss'),
  ),
  'investor-pages-document-vault': lazy(
    async () => import('@/widgets/investor/InvestorDocumentVaultWidget'),
  ),
  'investor-performance-report': lazy(
    async () => import('@/widgets/investor/PerformanceReport'),
  ),
  'investor-pfs': lazy(
    async () => import('@/widgets/investor/PersonalFinancialStatement'),
  ),
  // Legacy aliases for keys still used by Salesforce / backend dashboard configs
  /** Full balance sheet page body (`/Investor/BalanceSheet`) — charts, table, historical. */
  'investor-balancesheet-chart': lazy(
    async () => import('@/widgets/investor/balanceSheetChartWidget'),
  ),
  /** Dashboard accounts accordion (home dashboard balance sheet tile). */
  'investor-balancesheet-grid': lazy(
    async () => import('@/widgets/investor/balanceSheetWidget'),
  ),
  'investor-confidence-meter': lazy(
    async () => import('@/widgets/investor/dashboardConfidenceMeter'),
  ),
  'investor-mgp-meter': lazy(
    async () => import('@/widgets/investor/dashboardConfidenceMeter'),
  ),
};

export default investorWidgetMap;
